export default __webpack_public_path__ + "static/media/dinersclub.e9378d0a.svg";